import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ContemporaryLandingHeroMakerRow } from './ContemporaryLandingHeroMakerRow';
import { ContemporaryLandingMakerRow } from './ContemporaryLandingMakerRow';

import styles from './ContemporaryLandingMakersModule.scss';

const ContemporaryLandingMakersModuleComponent = ({ contemporaryLandingRow }) => {
    if (!contemporaryLandingRow || !contemporaryLandingRow.items) {
        return null;
    }

    const heroMakerRow = contemporaryLandingRow.items.find(item => item.type === 'heroMakerRow');
    const makerRows = contemporaryLandingRow.items.filter(item => item.type === 'makerRow');

    return (
        <div className={styles.wrapper}>
            <BarHeader title={get(contemporaryLandingRow, 'items[0].text')} />
            <ContemporaryLandingHeroMakerRow heroMakerRow={heroMakerRow} />
            <div className={styles.makerRows}>
                {makerRows.map((makerRow, index) => (
                    <ContemporaryLandingMakerRow
                        key={`${makerRow.text}-${index}`}
                        items={get(makerRow, 'items')}
                    />
                ))}
            </div>
        </div>
    );
};

ContemporaryLandingMakersModuleComponent.propTypes = {
    contemporaryLandingRow: PropTypes.object,
};

export const ContemporaryLandingMakersModule = createFragmentContainer(
    ContemporaryLandingMakersModuleComponent,
    {
        contemporaryLandingRow: graphql`
            fragment ContemporaryLandingMakersModule_contemporaryLandingRow on ContemporaryLandingRow {
                ... on ContemporaryLandingRow {
                    items {
                        ... on ContemporaryLandingHeader {
                            text
                            type
                        }
                        ... on ContemporaryLandingRow {
                            items {
                                ... on ContemporaryLandingHeroMakerRowItem {
                                    bgImagePath
                                    location
                                    name
                                    type
                                    url
                                    userImagePath
                                }
                                ... on ContemporaryLandingMakerRowItem {
                                    imagePath
                                    text
                                    type
                                    url
                                }
                            }
                            type
                        }
                    }
                }
            }
        `,
    }
);
